import { IGlobalProductEntity, PRODUCT_NAMES } from 'components/BusinessToolForm/Sections/Global/general/products';

import { ObjectValues } from 'helpers/types';

const salesPlanRequiredFields: ObjectValues<typeof PRODUCT_NAMES>[] = [
  PRODUCT_NAMES.PRICE,
  PRODUCT_NAMES.MONTHLY_SALES_PLAN_PHYSICAL,
];
export const isAllSalesPlanRequiredFieldsFilled = (product: IGlobalProductEntity): boolean => {
  return salesPlanRequiredFields.every((requiredField) => !!product[requiredField]);
};

export const getProductFieldsForSalesPlan = (product: IGlobalProductEntity) => {
  return {
    productName: product[PRODUCT_NAMES.NAME],
    productPrice: product[PRODUCT_NAMES.PRICE],
    monthlySalesPlanPhysical: product[PRODUCT_NAMES.MONTHLY_SALES_PLAN_PHYSICAL],
    annualSalesGrowthRate: product[PRODUCT_NAMES.ANNUAL_SALES_GROWTH_RATE],
    annualPriceGrowthRate: product[PRODUCT_NAMES.ANNUAL_PRICE_GROWTH_RATE],
  };
};
